var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as reducers from '../reducers';
import { getEntities, MEMO_CATEGORIES } from '../reducers';
import { createSelector } from 'reselect';
export var getPopularCategories = createSelector(reducers.getStatisticsState, getEntities(MEMO_CATEGORIES), function (stats, categories) {
    if (!stats.memos.data || !stats.memos.data.categories) {
        return [];
    }
    return Object.getOwnPropertyNames(stats.memos.data.categories)
        .map(function (value) { return (__assign({ score: stats.memos.data.categories[value] }, categories[value])); })
        .filter(function (cat) { return cat.score > 0; })
        .filter(function (cat) { return cat.name != undefined; })
        .sort(function (a, b) {
        if (a.score > b.score)
            return -1;
        if (a.score === b.score)
            return 0;
        return 1;
    });
});
export var getActiveMembers = createSelector(reducers.statistics.getMembersStats, getEntities('staff'), function (stats, staff) {
    if (!stats || !stats.data) {
        return [];
    }
    return stats.data.map(function (stat) { return (__assign({}, stat, { member: staff[stat.memberId] })); }).sort(function (a, b) {
        if (a.memoCreated === undefined) {
            a.memoCreated = 0;
        }
        if (b.memoCreated === undefined) {
            b.memoCreated = 0;
        }
        if (a.memoCreated < b.memoCreated) {
            return 1;
        }
        if (a.memoCreated > b.memoCreated) {
            return -1;
        }
        return 0;
    });
});
export var getActiveCustomers = createSelector(reducers.statistics.getCustomersStats, getEntities('customers'), function (stats, customers) {
    if (!stats || !stats.data) {
        return [];
    }
    return stats.data
        .map(function (stat) { return (__assign({}, stat, { customer: customers[stat.customerId] })); })
        .sort(function (a, b) {
        if (a.memoCreated === undefined) {
            a.memoCreated = 0;
        }
        if (b.memoCreated === undefined) {
            b.memoCreated = 0;
        }
        if (a.memoCreated < b.memoCreated) {
            return 1;
        }
        if (a.memoCreated > b.memoCreated) {
            return -1;
        }
        return 0;
    });
});
